import { Row } from "antd";
import logo from "../../assets/img/logo2.png";

const Header = (props) => {
  return (
    <>
      <Row className="lock-certificate-header">
        <img src={logo} className="logo" alt="logo" 
        width={300} height="auto"
        />
      </Row>
    </>
  );
};
export default Header;
